/** Build-time gate for the Saved Views V2 vertical (mirrors VITE_FLAG_SELECTIONS_VALIDATION). */
export function isViewsV2Enabled(): boolean {
  return import.meta.env.VITE_FLAG_VIEWS_V2 === "true";
}
